import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HotToastService } from '@ngneat/hot-toast';
import { Observable, of, Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppointmentService } from 'src/app/modules/appointments/_services/appointments.service';
import { AuthService } from 'src/app/modules/auth';
import { AuthModel } from 'src/app/modules/auth/_models/auth.model';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { LabService } from 'src/app/modules/lab/_services';
@Component({
  selector: 'app-confirm-save-modal',
  templateUrl: './confirm-save-modal.component.html',
  styleUrls: ['./confirm-save-modal.component.scss']
})
export class ConfirmSaveModalComponent implements OnInit, OnDestroy  {
  language: any;
  hasError: boolean;
  ErrorMessage: string;
  private unsubscribe: Subscription[] = [];
  isLoading$: Observable<boolean>;
  @Input() DoctorId : number;
  @Input() DepartmentId:string;
  @Input() Slot : any;
  @Input() PatientProfile : any;
  @Input() GuestProfile : any;
  Service:string = '';
  MeetingType:number ;
  constructor(private translationService: TranslationService, private authService: AuthService,private route: ActivatedRoute,
    private toast: HotToastService,private AppointmentService : AppointmentService,private router: Router,
   public modal: NgbActiveModal) { this.isLoading$ = this.authService.isLoading$; }
  ngOnInit(): void {
    if (localStorage.getItem("Service")) {
      this.Service = localStorage.getItem("Service");
    }
    this.language = this.translationService.getSelectedLanguage();
  }
  onNoClick(): void {
    this.modal.close();
  }
  ConfirmSaveAppointment() {
    // if (!this.MeetingType || this.MeetingType == 0 || this.MeetingType == null)
    // {
    //   if (this.language == "ar") {
    //     this.toast.warning("<b>يجب اختيار نوع الحجز اولا</b>", { style: { padding: '20px' } });
    //   }
    //   else {
    //     this.toast.warning("<b>You must choose the type of appointment first</b>", { style: { padding: '20px' } });
    //   }
    //   return;
    // }
    this.AppointmentService.showLoader();
    let saveAppointmentModel ;
    if (this.PatientProfile && this.PatientProfile != null)
    {
      saveAppointmentModel =
      {
        //  ApiPatientID : this.PatientProfile.patientId,
         ApiDocID : this.DoctorId,
         ApiFrom : this.Slot.fromTime,
         ApiTo: this.Slot.toTime,
         ApiFName : this.PatientProfile.firstName,
         ApiLName : this.PatientProfile.lastName,
         ApiGender : this.PatientProfile.gender,
         Mobile : this.PatientProfile.mobile,
         ApiAge : this.PatientProfile.age,
        //  MeetigType : this.MeetingType
      }
    }
    else if (this.GuestProfile && this.GuestProfile != null)
    {
      saveAppointmentModel =
      {
        //  ApiPatientID : null,
         ApiDocID : this.DoctorId,
         ApiFrom : this.Slot.fromTime,
         ApiTo: this.Slot.toTime,
         ApiFName : this.GuestProfile.fName,
         ApiLName : this.GuestProfile.lName,
         ApiGender : this.GuestProfile.gender,
         Mobile : this.GuestProfile.mobile,
         ApiAge : this.GuestProfile.age,
        //  MeetigType : this.MeetingType
        //  IqamaID : this.GuestProfile.iqamaId,
 
      }
    }
    else
    {
      sessionStorage.setItem('DepartmentId',this.DepartmentId);
      sessionStorage.setItem('DoctorId',this.DoctorId.toString());
      this.router.navigate(['/login' ], { relativeTo: this.route });
      return
    }
    const Subscr = this.AppointmentService.SaveAppointment(saveAppointmentModel).pipe(
      catchError((errorMessage) => {
        this.authService.hideLoader();
        return of(errorMessage);
      })
    ).subscribe(res => {
      
      if (res.isSuccess && res.responseCode == 200) {
        this.toast.success("<b>" + res.message + "</b>", { style: { padding: '20px' } });
        this.authService.hideLoader();
        this.onNoClick();
        if (this.Service == 'BookAppointment')
        {
          // let AppointmentDetails : any = {
          //   AptDate : this.Slot.fromTime,
          // };
          
          localStorage.setItem('AppointmentDetails',JSON.stringify(res.data))
          this.router.navigate(['/portal/appointments/another-service/']);
        }
        else
        {
          this.router.navigate(['/portal/appointments/search/']);

        }

        this.AppointmentService.fetch();
      }
      else if (res.error?.status == 401) {
        var refreshToken = JSON.parse(localStorage.getItem("RefreshToken"));
        let GuestId = this.GuestProfile?.userId == null ? 0 : this.GuestProfile.userId;
        let PatientId = this.PatientProfile?.patientId == null ? 0 : this.PatientProfile.patientId;

        const RefreshToken = this.authService.RefreshToken(PatientId, GuestId, refreshToken).subscribe(resl => {
          if (resl.userId && resl.userId != 0 && resl.userId != null) {
            this.ConfirmSaveAppointment();
          }
          else {
            if (this.language == "ar") {
              this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
            }
            else {
              this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
            }
          }
        });
        this.unsubscribe.push(RefreshToken);
        this.authService.hideLoader();

      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 404) {
        this.toast.warning("<b>" + res.error?.message + "</b>", { style: { padding: '20px' } });
        this.authService.hideLoader();
      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 500) {
        if (this.language == "ar") {
          this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
        }
        else {
          this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
        }
        this.authService.hideLoader();

      }
      else {
        if (this.language == "ar") {
          this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
        }
        else {
          this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
        }
        this.authService.hideLoader();

      }
    });
    this.unsubscribe.push(Subscr);
  }
  
  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
